<template>
  <div
    v-if="atLeastOneChildIsAccessible()"
    ref="dropdownRef"
    class="dropdown-hover dropdown dropdown-end dropdown-bottom flex shrink-0">
    <div
      tabindex="0"
      class="hover:bg-white/10 transition-colors flex cursor-pointer items-center rounded px-3 py-2"
      :class="titleClass"
      :data-test="testKey">
      <component
        :is="icon"
        v-if="icon"
        :size="16"
        class="mr-2" />
      <span class="font-medium text-white">{{ title }}</span>
    </div>
    <ul
      tabindex="0"
      class="dropdown-content menu z-50 mt-0 w-max min-w-52 rounded-md border border-solid border-gray-200 bg-base-100 p-2 shadow-lg">
      <template
        v-for="(
          {
            title: linkTitle,
            to,
            href,
            icon: linkIcon,
            subtitle,
            divider,
            download,
            testKey: linkTestKey,
            disabled,
            hidden,
            chipTitle: linkChipTitle,
            badge: linkBadge,
          },
          idx
        ) in links"
        :key="idx">
        <li
          v-if="divider"
          role="separator"
          class="my-1 border-t border-gray-200" />
        <li v-else-if="hasAccess(to) && !hidden">
          <router-link
            v-if="to"
            :to="to"
            :data-test="linkTestKey"
            :title="linkTitle"
            :class="{ 'pointer-events-none opacity-50': disabled }"
            class="flex items-center gap-2 px-3 py-2"
            @click="closeMenu">
            <component
              :is="linkIcon"
              v-if="linkIcon"
              :size="16"
              class="shrink-0" />
            <span class="flex flex-col">
              <span>{{ linkTitle }}</span>
              <span
                v-if="subtitle"
                class="text-xs text-gray-500"
                >{{ subtitle }}</span
              >
            </span>
            <span
              v-if="linkBadge"
              class="inline-flex shrink-0 items-center rounded-full bg-gradient-to-r from-indigo-500 to-purple-500 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-white shadow-sm">
              {{ linkBadge }}
            </span>
            <div
              v-if="linkChipTitle"
              class="ml-auto badge badge-sm badge-accent">
              {{ linkChipTitle }}
            </div>
          </router-link>
          <a
            v-else-if="href"
            :href="href"
            :download="download"
            :data-test="linkTestKey"
            :title="linkTitle"
            :class="{ 'pointer-events-none opacity-50': disabled }"
            class="flex items-center gap-2 px-3 py-2"
            @click="closeMenu">
            <component
              :is="linkIcon"
              v-if="linkIcon"
              :size="16"
              class="shrink-0" />
            <span class="flex flex-col">
              <span>{{ linkTitle }}</span>
              <span
                v-if="subtitle"
                class="text-xs text-gray-500"
                >{{ subtitle }}</span
              >
            </span>
            <span
              v-if="linkBadge"
              class="inline-flex shrink-0 items-center rounded-full bg-gradient-to-r from-indigo-500 to-purple-500 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-white shadow-sm">
              {{ linkBadge }}
            </span>
            <div
              v-if="linkChipTitle"
              class="ml-auto badge badge-sm badge-accent">
              {{ linkChipTitle }}
            </div>
          </a>
        </li>
      </template>
    </ul>
    <div
      v-if="showBorder"
      class="h-1/2 w-px self-center bg-primary" />
  </div>
</template>

<script>
import { ref } from 'vue';
import { RouterLink } from 'vue-router';
import store from '@/store';
import { IsUserAnAdmin } from '@/utilities/AuthUtils';

export default {
  name: 'NavMenuItem',
  components: { RouterLink },
  props: {
    titleClass: String,
    testKey: String,
    icon: Object,
    title: String,
    links: Array,
    showBorder: Boolean,
    chipTitle: String,
  },
  setup() {
    const dropdownRef = ref(null);

    const closeMenu = () => {
      console.log('[NavMenuItem] closeMenu called - blurring dropdown');
      // Blur any focused element within the dropdown
      if (dropdownRef.value) {
        const focusedElement = dropdownRef.value.querySelector(':focus');
        if (focusedElement) {
          focusedElement.blur();
          console.log('[NavMenuItem] blurred focused element:', focusedElement);
        }
      }
    };

    return { dropdownRef, closeMenu };
  },
  methods: {
    hasAccess(to) {
      const user = store.state.user;
      if (!user) return false;
      if (IsUserAnAdmin(user)) return true;
      if (!to) return true;
      return !!this.$router.resolve(to);
    },
    atLeastOneChildIsAccessible() {
      return this.links.map((l) => !l.hidden && this.hasAccess(l.to)).includes(true);
    },
  },
};
</script>
